// extracted by mini-css-extract-plugin
var _1 = "ListTableBodyRow_bodyRow__u+dhz";
var _2 = "ListTableBodyRow_interactive__hQKo6";
export { _1 as "bodyRow", _2 as "interactive" }
